import { render, staticRenderFns } from "./Richieste-Accesso.vue?vue&type=template&id=a65bb274&scoped=true&"
import script from "./Richieste-Accesso.vue?vue&type=script&lang=js&"
export * from "./Richieste-Accesso.vue?vue&type=script&lang=js&"
import style0 from "./Richieste-Accesso.vue?vue&type=style&index=0&id=a65bb274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65bb274",
  null
  
)

export default component.exports